import setCookieAndLoadProfile from "../../../utils/setCookieAndLoadProfile";
import redirectIfNotLoggedIn from "../../../utils/redirectIfNotLoggedIn";
import loadBasicPotluckAppData from "../../../utils/loadBasicPotluckAppData";
import PotluckApp from "../../../onsen-apps/PotluckApp";

const initialStack = ["/profile/plan", "/profile/plan/pause"];

const ProfilePlanPause = (props) => <PotluckApp initialStack={initialStack} />;

ProfilePlanPause.getInitialProps = async (context) => {
  const profile = await setCookieAndLoadProfile(context);

  if (profile) {
    return await loadBasicPotluckAppData(context);
  } else {
    redirectIfNotLoggedIn(context);
  }
};

export default ProfilePlanPause;
